var map = {
	"./aac/bgm_main_en.aac": "409a",
	"./aac/bgm_main_jp.aac": "886f",
	"./m4a/bgm_main_en.m4a": "c4e8",
	"./m4a/bgm_main_jp.m4a": "baa2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac03";